import { FavouriteRelease } from '@/model/favouriterelease.model';

const LS_KEY = 'liga-favourite-releases-v1';

export function loadFavouriteReleasesFromLocalStorage(): FavouriteRelease[] {
  try {
    if (typeof localStorage === 'undefined') return [];
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw) as { id: string; favourite?: boolean }[];
    if (!Array.isArray(arr)) return [];
    return arr.map((x) => {
      const fr = new FavouriteRelease(String(x.id));
      fr.favourite = !!x.favourite;
      return fr;
    });
  } catch {
    return [];
  }
}

export function saveFavouriteReleasesToLocalStorage(favourites: FavouriteRelease[]): void {
  if (typeof localStorage === 'undefined') return;
  const payload = favourites.map((f) => ({ id: f.id, favourite: !!f.favourite }));
  localStorage.setItem(LS_KEY, JSON.stringify(payload));
}
